import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth, setSessionToken } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash;

        let sessionJwt = null;
        let nonce = null;

        if (hash.includes('id_token=')) {
          // Direct Google OAuth callback (id_token flow)
          const params = new URLSearchParams(hash.substring(1));
          sessionJwt = params.get('id_token');
          nonce = sessionStorage.getItem('google_nonce');
          sessionStorage.removeItem('google_nonce');
        } else if (hash.includes('access_token=')) {
          // Legacy fallback
          const params = new URLSearchParams(hash.substring(1));
          sessionJwt = params.get('access_token');
        } else if (hash.includes('session_id=')) {
          const m = hash.match(/session_id=([^&]+)/);
          sessionJwt = m ? m[1] : null;
        }

        if (!sessionJwt) {
          navigate('/');
          return;
        }

        const response = await axios.post(`${API}/auth/session`, { session_id: sessionJwt, nonce });

        if (response.data.session_token) {
          setSessionToken(response.data.session_token);
        }
        setUser(response.data.user);

        if (!response.data.user.subscription_plan || response.data.user.subscription_plan === 'usuario') {
          navigate('/select-plan', { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/');
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#050508' }}>
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#c9a84c] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#7a7870] text-sm">Autenticando con Google...</p>
      </div>
    </div>
  );
};
